import ValidationType from '~components/form/js/validation-type';

class ValidationTypeExtend extends ValidationType {
    constructor(form, error, element) {
        super(form, error, element);
    }

    validationMessage(labelText) {
        if(this.element.hasAttribute('js-validation-message')) return this.element.getAttribute('js-validation-message');

        switch(this.language) {
            case 'nl':
                return `Dit is geen geldige waarde voor het '${labelText.replace('*','').trim()}' veld.`;
            case 'en':
                return `This is not a valid value for the '${labelText.replace('*','').trim()}' field.`;
            case 'de':
                return `Dies ist kein gültiger Wert für das Feld '${labelText.replace('*','').trim()}'.`;
            case 'es':
                return `Este no es un valor válido para el campo '${labelText.replace('*','').trim()}'.`;
            case 'fr':
                return `Ce n'est pas une valeur valide pour le champ '${labelText.replace('*','').trim()}'.`;
            default:
                return `This is not a valid value for the '${labelText.replace('*','').trim()}' field.`;
        }
    }

    getRegex(sort) {
      let validation;
      
      switch (sort){
          case 'phone':
              validation = /^((\s|[\.\-\+\(\)\[\]])*[0-9]){6,14}$/;
          break;
          case 'email':
              validation = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          break;
          case 'zip':
              validation = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
          break;
          case 'date':
              validation = /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(-)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
          break;
          case 'url':
              validation = /^(http|https)?:\/\/(\S+)$/;
          break;
          case 'password':
              validation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*&%$).{6,}$/;
          break;
          default:
              validation = false;
          break;
      }
      return validation;
    }
}

export default ValidationTypeExtend;
